import { AuthService } from '../services/auth';

export class AuthComponent {
  private authService: AuthService;
  private container: HTMLElement;

  constructor(authService: AuthService, container: HTMLElement) {
    this.authService = authService;
    this.container = container;
  }

  render(): void {
    this.container.innerHTML = `
      <div class="auth-form">
        <h2>💎 Partner Sign In</h2>
        <p>Please sign in to access your partner dashboard</p>
        <form id="signin-form">
          <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" required>
          </div>
          <div class="form-group">
            <label for="password">Password:</label>
            <input type="password" id="password" required>
          </div>
          <button type="submit">Sign In</button>
          <div id="auth-error" class="error" style="display: none;"></div>
        </form>
      </div>
    `;

    this.attachEventListeners();
  }

  private attachEventListeners(): void {
    const form = this.container.querySelector('#signin-form') as HTMLFormElement;
    const errorElement = this.container.querySelector('#auth-error') as HTMLElement;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const email = (this.container.querySelector('#email') as HTMLInputElement).value;
      const password = (this.container.querySelector('#password') as HTMLInputElement).value;

      try {
        errorElement.style.display = 'none';
        await this.authService.signIn(email, password);
      } catch (error) {
        errorElement.textContent = error instanceof Error ? error.message : 'Sign in failed';
        errorElement.style.display = 'block';
      }
    });
  }
}
